<template>
  <div>
    <div>
      <el-form size="small" label-width="100px" class="margin15-tb">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="场景名称">
              <el-input clearable v-model="sceneName" placeholder="请输入场景名称"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="场景描述">
              <el-input clearable v-model="sceneDesc" placeholder="请输入场景描述"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <div class="text left">
              <el-button type="primary" size="mini" @click="search"><i class="fa fa-search"></i>搜索</el-button>
              <el-button size="mini" @click="reset" style="width: 70px;">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <p>
        <el-button icon="el-icon-circle-plus-outline" type="primary" size="small" @click="addScene">创建场景</el-button>
        <el-button icon="el-icon-copy-document" type="primary" size="small" @click="copySceneButton">复制场景</el-button>
      </p>
    </div>
    <div class="padding15-tb">
      <el-table
        :data="list"
        v-loading="loading"
        size="small"
        border
        stripe
        :header-cell-style="{textAlign: 'center'}"
        style="width: 100%">
        <el-table-column
          prop="sceneName"
          align="center"
          label="场景名称"
          width="200px">
        </el-table-column>
        <el-table-column
          prop="sceneDesc"
          align="center"
          label="场景描述">
        </el-table-column>
        <el-table-column
          prop="recorder"
          align="center"
          label="录音员">
          <template slot-scope="scope">
              <span v-if="scope.row.recorder">{{ scope.row.recorder }}</span>
              <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="filedsShow"
          align="center"
          label="提前生成参数">
          <template slot-scope="scope">
            <span v-if="scope.row.filedsShow === '' || scope.row.filedsShow == null">--</span>
            <div v-else v-html="scope.row.filedsShow"></div>
          </template>
        </el-table-column>
        <el-table-column
          prop="transferSceneName"
          align="center"
          label="转人工场景名称">
          <template slot-scope="scope">
            <span v-if="scope.row.transferSceneName === '' || scope.row.transferSceneName == null">--</span>
            <span v-else v-html="scope.row.transferSceneName"></span>
          </template>
        </el-table-column>
        <el-table-column
          prop="typeName"
          align="center"
          label="场景类型">
          <template slot-scope="scope">
            <div :style="{ color: scope.row.type =='1' ? '#E6A23C' : '' }">
              {{ scope.row.typeName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="callWordShow"
          align="center"
          label="场景提示词"
          min-width="160px">
          <template slot-scope="scope">
            <span v-if="scope.row.callWordShow === '' || scope.row.callWordShow == null">--</span>
            <div v-else-if="scope.row.callWordShow.length < 150" v-html="scope.row.callWordShow"></div>
            <el-tooltip v-else effect="light" placement="top">
              <template #content>
                <div slot="content" v-html="scope.row.callWordShow" style="width: 350px; word-wrap: break-word;"></div>
              </template>
              <div v-html="scope.row.callWordShow.substring(0,30) + '...'"></div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="isInterrupt"
          align="center"
          label="是否可打断">
          <template slot-scope="scope">
            <span v-if="scope.row.isInterrupt">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="isFlashMsg"
          align="center"
          label="是否发送闪信">
          <template slot-scope="scope">
            <span v-if="scope.row.isFlashMsg">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="150px">
          <template slot-scope="scope">
            <el-button type="text" size="medium" icon="el-icon-guide" @click="routeSceneShow(scope.row)" style="color: #816DF1 !important;"></el-button>
            <el-button type="text" size="medium" icon="el-icon-edit-outline" @click="editScene(scope.row)" style="color: #816DF1 !important;"></el-button>
            <el-button type="text" size="medium" icon="el-icon-copy-document" @click="copyScene(scope.row)" style="color: #816DF1 !important;"></el-button>
            <el-button type="text" size="medium" icon="el-icon-delete" @click="deleteScene(scope.row.id)" style="color: #F57E50 !important;"></el-button>
            &nbsp;
            <el-switch
              v-model="scope.row.status"
              @change="openAndCloseScene(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
      <div class="text center margin15-tb">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageData.currentPage"
          :page-sizes="[50, 100, 200]"
          :page-size="pageData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageData.totalCount">
        </el-pagination>
      </div>
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="sceneVisible"
      center
      width="55%">
      <el-form size="small" label-width="180px">
        <el-form-item label="场景名称">
          <el-input v-model="addOrUpdate.sceneName" placeholder="请输入场景名称" style="width: 80%;"/>
        </el-form-item>
        <el-form-item label="场景描述">
            <el-input v-model="addOrUpdate.sceneDesc" type="textarea" :rows="4" placeholder="请输入场景描述" style="width: 80%;"/>
        </el-form-item>
        <el-form-item label="提前生成参数">
          <el-select
            v-model="addOrUpdate.fileds"
            multiple
            collapse-tags
            filterable
            style="width: 80%;"
            placeholder="请选择">
            <el-option
              v-for="item in templateFiledOptions"
              :key="item.paramCode"
              :label="item.description"
              :value="item.paramCode">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="转人工场景">
          <el-select v-model="addOrUpdate.transferSceneId" placeholder="请选择" style="width: 80%;" filterable>
            <el-option
              label="请选择"
              :value="''">
            </el-option>
            <el-option
              v-for="item in transferSceneOption"
              :key="item.id"
              :label="item.sceneName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="场景类型">
          <el-select v-model="addOrUpdate.type" :value="addOrUpdate.type" @change="changeSceneType" placeholder="请选择"  style="width: 80%;" filterable>
            <el-option
              v-for="item in sceneTypeOption"
              :key="item.code"
              :label="item.desc"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交互轮次" v-show="showCallWord">
            <el-input-number v-model="addOrUpdate.callRound" controls-position="right" :min="1" :max="20" placeholder="请输入交互轮次" style="width: 80%;"/>
        </el-form-item>
        <el-form-item label="场景提示词" v-show="showCallWord">
          <div id="manualSendMessageContent" v-html="addOrUpdate.callWordShow" rows="8" contentEditable="plaintext-only"  style="width: 80%;height: 150px;border: 1px solid #dcdfe6;border-radius: 4px; overflow-y: auto;'"></div>
        </el-form-item>
        <el-tabs v-model="addTemplateActiveTab" style="margin-left: 5%;" v-show="showCallWord">
          <el-tab-pane label="基本信息" name="baseInfo">
            <el-button
              type="text"
              class="paramter-select"
              v-for="item in templateFiled.baseInfo"
              :key="item.id"
              :title = "internationalVersionFlag == 1 ? (languageSelect === '0' ? item.description : (item.descriptionTrans || item.description)) : null"
              z-index = "999"
              @click="addParamter(item, '')">
              {{internationalVersionFlag == 1 && languageSelect === '0' ? (item.descriptionTrans || item.description) : item.description}}
            </el-button>
            &nbsp;
          </el-tab-pane>
          <el-tab-pane label="金额参数" name="overdueInfo">
            <el-button
              type="text"
              class="paramter-select"
              v-for="item in templateFiled.orgMoneyParam"
              v-if="!(item.flag && calculation.visible)"
              :key="item.id">
              <el-button
                type="text"
                class="editParamClass"
                :title = "internationalVersionFlag == 1 ? (languageSelect === '0' ? item.description : (item.descriptionTrans || item.description)) : null"
                z-index = "999"
                @click="addParamter(item, 'money')">
                {{internationalVersionFlag == 1 && languageSelect === '0' ? (item.descriptionTrans || item.description) : item.description}}
              </el-button>
              &nbsp;
            </el-button>
            &nbsp;
          </el-tab-pane>
          <el-tab-pane label="时间参数" name="timeInfo">
            <el-button
              type="text"
              class="paramter-select"
              v-for="item in templateFiled.timeParam"
              :key="item.id"
              :title = "internationalVersionFlag == 1 ? (languageSelect === '0' ? item.description : (item.descriptionTrans || item.description)) : null"
              z-index = "999"
              @click="addParamter(item, '')">
              {{internationalVersionFlag == 1 && languageSelect === '0' ? (item.descriptionTrans || item.description) : item.description}}
            </el-button>
            &nbsp;
          </el-tab-pane>
          <el-tab-pane label="还款信息" name="repaymentInfo">
            <el-button
              type="text"
              class="paramter-select"
              v-for="item in templateFiled.payInfo"
              :key="item.id"
              :title = "internationalVersionFlag == 1 ? (languageSelect === '0' ? item.description : (item.descriptionTrans || item.description)) : null"
              z-index = "999"
              @click="addParamter(item, '')">
              {{internationalVersionFlag == 1 && languageSelect === '0' ? (item.descriptionTrans || item.description) : item.description}}
            </el-button>
            &nbsp;
          </el-tab-pane>
          <el-tab-pane label="公开信息" name="publicInfo">
            <el-button
              type="text"
              class="paramter-select"
              v-for="item in templateFiled.execInfo"
              :key="item.id"
              :title = "internationalVersionFlag == 1 ? (languageSelect === '0' ? item.description : (item.descriptionTrans || item.description)) : null"
              z-index = "999"
              @click="addParamter(item, '')">
              {{internationalVersionFlag == 1 && languageSelect === '0' ? (item.descriptionTrans || item.description) : item.description}}
            </el-button>
            &nbsp;
          </el-tab-pane>
          <el-tab-pane label="拓展信息" name="expandInfo">
            <el-button
              type="text"
              class="paramter-select"
              v-for="item in templateFiled.expandInfo"
              :key="item.id"
              :title = "internationalVersionFlag == 1 ? (languageSelect === '0' ? item.description : (item.descriptionTrans || item.description)) : null"
              z-index = "999"
              @click="addParamter(item, '')">
              {{internationalVersionFlag == 1 && languageSelect === '0' ? (item.descriptionTrans || item.description) : item.description}}
            </el-button>
            &nbsp;
          </el-tab-pane>
          <el-tab-pane label="自定义参数" name="selfDefinedParam">
            <el-button
              type="text"
              class="paramter-select"
              v-for="item in templateFiled.selfDefinedParam"
              :key="item.id"
              :title = "internationalVersionFlag == 1 ? (languageSelect === '0' ? item.description : (item.descriptionTrans || item.description)) : null"
              z-index = "999"
              @click="addParamter(item, '')">
              {{internationalVersionFlag == 1 && languageSelect === '0' ? (item.descriptionTrans || item.description) : item.description}}
            </el-button>
            &nbsp;
          </el-tab-pane>
          <el-tab-pane label="逻辑参数" name="logicParam">
            <el-button
              type="text"
              class="paramter-select"
              v-for="item in templateFiled.logicParam"
              :key="item.id"
              :title = "internationalVersionFlag == 1 ? (languageSelect === '0' ? item.description : (item.descriptionTrans || item.description)) : null"
              z-index = "999"
              @click="addParamter(item, '')">
              {{internationalVersionFlag == 1 && languageSelect === '0' ? (item.descriptionTrans || item.description) : item.description}}
            </el-button>
            &nbsp;
          </el-tab-pane>
          <el-tab-pane label="字典转译参数" name="dzyParam">
            <el-button
              type="text"
              class="paramter-select"
              v-for="item in templateFiled.dzyParam"
              :key="item.id"
              :title = "internationalVersionFlag == 1 ? (languageSelect === '0' ? item.description : (item.descriptionTrans || item.description)) : null"
              z-index = "999"
              @click="addParamter(item, '')">
              {{internationalVersionFlag == 1 && languageSelect === '0' ? (item.descriptionTrans || item.description) : item.description}}
            </el-button>
            &nbsp;
          </el-tab-pane>
          &nbsp;
        </el-tabs>
        <el-form-item label="回铃模版" v-if="isSceneType === 1">
          <el-select v-model="addOrUpdate.transferRingTemplateId" style="width: 80%;" filterable>
            <el-option :key="0" label="不配置" :value ="0"></el-option>
            <el-option
              v-for="item in templateList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
              <template>
                <el-tooltip placement="top" effect="light">
                  <div slot="content" v-html="item.contentShow ? item.contentShow : item.content"></div>
                  <span>{{item.name}}</span>
                </el-tooltip>
              </template>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否可打断">
          <el-switch
            v-model="addOrUpdate.isInterrupt">
          </el-switch>
        </el-form-item>
        <el-form-item v-if="addOrUpdate.isInterrupt" label="是否首句可打断">
          <el-switch
            v-model="addOrUpdate.isFirstInterrupt">
          </el-switch>
        </el-form-item>
        <el-form-item label="接听后首次等待时长 (秒)">
          <el-input-number v-model="addOrUpdate.firstTimeout"   :min="1" :max="5" label=""></el-input-number>
        </el-form-item>
        <el-form-item label="是否发送闪信">
          <el-switch
            v-model="addOrUpdate.isFlashMsg"
            @change="handleImmediatelyMsgChange">
          </el-switch>
        </el-form-item>
        <el-form-item label="闪信模板" v-if="addOrUpdate.isFlashMsg">
          <el-select v-model="addOrUpdate.flashMsgTemplateId" placeholder="请选择" style="width: 80%;" filterable>
            <el-option
              v-for="item in flashMsgTemplateList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
              <el-tooltip effect="light" placement="top">
                <div slot="content" v-html="item.content || item.templateContent || item.template || item.name"></div>
                <span>{{ item.name }}</span>
              </el-tooltip>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="录音员">
          <el-select v-model="addOrUpdate.recorderId" placeholder="请选择录音员"  style="width: 80%;" filterable>
            <el-option
              v-for="item in recorderOption"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="sceneVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="addOrUpdateSceneTemplate" size="small">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="场景复制"
      :visible.sync="copySceneVisible"
      width="40%">
        <el-form size="small" label-width="140px">
          <el-form-item label="场景名称">
            <el-input v-model="copySceneReq.sceneName" placeholder="请输入场景名称" style="width: 80%;"/>
          </el-form-item>
          <el-form-item label="来源策略组公司">
            <el-select v-model="copySceneReq.sourceCompanyId" placeholder="请选择" @change="sourceCompanyChange" style="width: 80%;" filterable>
              <el-option
                v-for="item in companyOption"
                :key="item.id"
                :label="item.companyName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="来源策略组名称">
            <el-select v-model="copySceneReq.sourceGroupId" @change="getSceneList" placeholder="请选择" style="width: 80%;" filterable>
              <el-option
                v-for="item in groupOption"
                :key="item.id"
                :label="item.groupName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场景">
            <el-select v-model="copySceneReq.id"  placeholder="请选择" style="width: 80%;" filterable>
              <el-option
                v-for="item in sceneTemplateList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场景描述">
              <el-input v-model="copySceneReq.sceneDesc" type="textarea" :rows="4" placeholder="请输入场景描述" style="width: 80%;"/>
          </el-form-item>
          <el-form-item label="提前生成参数">
            <el-select
              v-model="copySceneReq.fileds"
              multiple
              collapse-tags
              filterable
              style="width: 80%;"
              placeholder="请选择">
              <el-option
                v-for="item in templateFiledOptions"
                :key="item.paramCode"
                :label="item.description"
                :value="item.paramCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="录音员">
          <el-select v-model="copySceneReq.recorderId" placeholder="请选择录音员"  style="width: 80%;" filterable>
            <el-option
              v-for="item in recorderOption"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="copySceneVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="copySceneSubmit" size="small">保存</el-button>
        </div>
      </el-dialog>

    <!-- 对话场景路由配置 -->
    <el-dialog title="对话场景路由配置" :visible.sync="routeSceneVisible" width="30%" center>
      <div>
        <el-form size="small" label-width="140px">
          <el-form-item label="对话场景路由">
            <el-select v-model="routeScene.routeConId" :value = "routeScene.routeConId" placeholder="请选择" style="width: 100%;" filterable clearable>
              <el-option
                v-for="item in routeSceneOption"
                :key="item.id"
                :label="item.confName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="routeSceneVisible = false" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="routeSceneSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  inject: ['reload'],
  props: {
    changeTabe: {
      type: String
    },
    companySelected: {
    },
    groupSelected: {
    }
  },
  watch: {
    changeTabe(type) {
      if (type === '对话语音场景') {
        if (this.companyId !== '') {
          this.getData(1);
          this.initTemplateFiled(this.companyId);
          this.getFiled(this.companyId);
          this.getCompanyOptionList();
          this.getRouteSceneOption();
        }
      }
    },
    companySelected(companyId) {
      this.companyId = companyId;
      this.addOrUpdate.companyId = companyId;
    },
    groupSelected(groupId) {
      this.groupId = groupId;
      this.addOrUpdate.groupId = groupId;
      if (this.changeTabe === '对话语音场景') {
        this.getData(1);
        this.getRouteSceneOption();
      }
    }
  },
  data() {
    return {
      templateFiledOptions: [],
      list: [],
      companyId: '',
      groupId: '',
      pageData: {},
      sceneName: null,
      sceneDesc: null,
      loading: true,
      sceneVisible: false,
      dialogTitle: null,
      addOrUpdate: {
        companyId: null,
        groupId: null,
        id: null,
        sceneName: null,
        sceneDesc: null,
        fileds: [],
        transferSceneId: [],
        type: null,
        isInterrupt: false,
        isFirstInterrupt: true,
        firstTimeout: 2,
        recorderId: null,
        transferRingTemplateId: 0,
        isFlashMsg: false,
        flashMsgTemplateId: null,
        callWord: null,
        callWordShow: null,
        callRound: null
      },
      copySceneVisible: false,
      companyOption: [],
      groupOption: [],
      transferSceneOption: [],
      sceneTypeOption: [],
      templateList: [],
      flashMsgTemplateList: [],
      isSceneType: 0,
      copySceneReq: {
        companyId: null,
        groupId: null,
        id: null,
        sceneName: null,
        sceneDesc: null,
        fileds: [],
        sourceCompanyId: null,
        sourceGroupId: null,
        recorderId: null
      },
      groupReq: {
        companyId: null
      },
      sceneTemplateList: [],
      recorderOption: [],
      routeSceneVisible: false,
      routeScene: {
        id: null,
        routeConId: null,
        type: 1
      },
      routeSceneReq: {
        type: 1
      },
      routeSceneOption: [],
      showCallWord: false,
      addTemplateActiveTab: 'baseInfo',
      templateFiled: {
        baseInfo: [],
        orgMoneyParam: [],
        timeParam: [],
        payInfo: [],
        execInfo: [],
        expandInfo: [],
        selfDefinedParam: [],
        logicParam: [],
        dzyParam: []
      },
      calculation: {
        buttonOption: {
          add: {
            text: '增加计算',
            iconClass: 'el-icon-plus'
          },
          cancle: {
            text: '取消',
            iconClass: 'el-icon-minus'
          },
          cancleEdit: {
            text: '取消编辑',
            iconClass: 'el-icon-minus'
          }
        },
        buttonSelect: '',
        visible: '',
        isEdit: '',
        req: {}
      },
      internationalVersionFlag: this.$getInternationalVersionFlag()
    };
  },
  mounted() {
  },
  methods: {
    getData(page) {
      this.loading = true;
      this.$ajax({
        url: '/scene/getSceneInfoList',
        method: 'POST',
        data: this.getSearchParam(page)
      }).then((res) => {
        this.list = [];
        this.$nextTick(() => {
          this.list = (res.data.list || []).map(item => Object.assign({}, item, {
            isFlashMsg: item.isFlashMsg !== undefined ? item.isFlashMsg : item.isImmediatelyMsg,
            flashMsgTemplateId: item.templateId || item.flashMsgTemplateId
          }));
          this.pageData.pageSize = res.data.limit;
          this.pageData.totalCount = res.data.totalRecords;
          this.pageData.currentPage = res.data.currentPage;
          this.loading = false;
        });
      });
    },
    initTemplateFiled(companyId) {
      console.warn(companyId);
      this.$ajax({
        url: '/template/getFiledListByCompanyId',
        params: { 'companyId': companyId }
      }).then((res) => {
        this.templateFiledOptions = res.data;
      });
    },
    getFiled(companyId) {
      this.$ajax({
        url: '/template/getFiled',
        params: { 'companyId': companyId }
      }).then((res) => {
        this.templateFiled.baseInfo = res.data.基本信息;
        this.templateFiled.orgMoneyParam = res.data.金额参数;
        this.templateFiled.timeParam = res.data.时间参数;
        this.templateFiled.payInfo = res.data.还款信息;
        this.templateFiled.execInfo = res.data.公开信息;
        this.templateFiled.expandInfo = res.data.拓展信息;
        this.templateFiled.selfDefinedParam = res.data.自定义参数;
        this.templateFiled.logicParam = res.data.逻辑参数;
        this.templateFiled.dzyParam = res.data.字典转译参数;
      });
    },
    checkNum() {
      this.buttonLoading = true;
      if (this.remoteSearchTimer) {
        clearTimeout(this.remoteSearchTimer);
      }
      this.remoteSearchTimer = setTimeout(() => {
        if ($('#manualSendMessageContent').html()) {
          this.$ajax({
            url: '/template/getContent',
            data: { originalContent: $('#manualSendMessageContent').html() }
          }).then((res) => {
            $('#manualSendMessageContent').html(res.data);
            // 光标移动到最后
            const selectId = 'manualSendMessageContent';
            this.keyAction(selectId);
          });
        }
        this.buttonLoading = false;
      }, 2000);
    },
    addParamter(item, parameterType) {
      let selectId;
      let html;
      // 根据不同的操作定点不同的文本框,在文本框中加入id不同的html
      if (parameterType === 'money' && this.calculation.visible) {
        // 正在添加或编辑计算公式
        selectId = 'formula';
        html = '<span id="pp'.concat(item.id, '" class="parameter" ondblclick="removeCt2(', item.id, ')" contentEditable="false"  style="color:red">', item.description, '<font id="', item.id, '" class="paramFont2" style="display: none">', item.paramCode, '</font></span>');
      } else {
        // 正在添加模板内容
        selectId = 'manualSendMessageContent';
        const description = selectId === 'manualSendMessageContent' ? item.description || item.descriptionTrans : item.descriptionTrans || item.description;
        html = '<span id="p'.concat(item.id, '" class="parameter" ondblclick="removeCt(', item.id, ')" contentEditable="false"  style="color:red">', description, '<font id="', item.id, '" class="paramFont" style="display: none">', item.paramCode, '</font></span>');
      }
      // 把光标放在最文本框的最后面
      const node = window.getSelection().anchorNode;
      if (node) {
        const idName = window.getSelection().getRangeAt(0).startContainer.parentNode.getAttribute('id');
        if (idName !== selectId) {
          this.keyAction(selectId);
        }
      } else this.keyAction(selectId);
      // 插入html
      this.insertHtmlAtCaret(html);
    },
    // 将内容插入到输入光标所在的位置
    insertHtmlAtCaret(html) {
      let sel;
      let range;
      if (window.getSelection) {
        // IE9 and non-IE
        sel = window.getSelection();
        if (sel.getRangeAt && sel.rangeCount) {
          range = sel.getRangeAt(0);
          range.deleteContents();
          // Range.createContextualFragment() would be useful here but is
          // non-standard and not supported in all browsers (IE9, for one)
          const el = document.createElement('div');
          el.innerHTML = html;
          const frag = document.createDocumentFragment();
          const node = el.firstChild;
          const lastNode = frag.appendChild(node);
          range.insertNode(frag);
          // Preserve the selection
          if (lastNode) {
            range = range.cloneRange();
            range.setStartAfter(lastNode);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
          }
        }
      } else if (document.selection && document.selection.type !== 'Control') {
        // IE < 9
        document.selection.createRange().pasteHTML(html);
      }
    },
    // 如果输入光标不在div内，则将光标强行移到div内内容的末端
    keyAction(id) {
      const textbox = document.getElementById(id);
      const sel = window.getSelection();
      const range = document.createRange();
      range.selectNodeContents(textbox);
      range.collapse(false);
      sel.removeAllRanges();
      sel.addRange(range);
    },
    // 公司列表
    getCompanyOptionList() {
      this.$ajax({
        url: '/company/getCompanyListJudgeRole',
        method: 'get'
      }).then((res) => {
        this.companyOption = res.data;
      });
    },
    sourceCompanyChange(companyId) {
      this.groupReq.companyId = companyId;
      this.$ajax({
        url: '/strategy/selectAllGroupsByCompanyIdOfUser',
        method: 'POST',
        data: this.groupReq
      }).then((res) => {
        this.groupOption = res.data;
        this.copySceneReq.sourceGroupId = res.data[0].id;
        this.getSceneList(this.copySceneReq.sourceGroupId);
      });
    },
    getSearchParam(page) {
      const req = {
        'companyId': this.companyId,
        'groupId': this.groupId,
        'sceneName': this.sceneName,
        'sceneDesc': this.sceneDesc,
        'page': page,
        'limit': this.pageData.pageSize || 50,
        'order': 0,
        'sort': 0
      };
      return req;
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.getData(1);
    },
    // 页码
    handleCurrentChange(val) {
      this.pageData.currentPage = val;
      this.getData(val);
    },
    search() {
      this.getData(1);
    },
    reset() {
      this.sceneName = null;
      this.sceneDesc = null;
    },
    addScene() {
      this.getRecorderList();
      this.dialogTitle = '创建场景';
      this.addOrUpdate.id = null;
      this.addOrUpdate.sceneName = null;
      this.addOrUpdate.sceneDesc = null;
      this.addOrUpdate.fileds = [];
      this.addOrUpdate.recorderId = null;
      this.sceneVisible = true;
      this.addOrUpdate.isInterrupt = false;
      this.addOrUpdate.isFirstInterrupt = true;
      this.addOrUpdate.firstTimeout = 2;
      this.addOrUpdate.transferSceneId = null;
      this.addOrUpdate.type = null;
      this.addOrUpdate.transferRingTemplateId = 0;
      this.addOrUpdate.isFlashMsg = false;
      this.addOrUpdate.flashMsgTemplateId = null;
      this.addOrUpdate.callWord = null;
      this.addOrUpdate.callWordShow = null;
      this.addOrUpdate.callRound = null;
      this.flashMsgTemplateList = [];
      this.isSceneType = 0;
      this.showCallWord = false;
      this.getTransferSceneInfo();
      this.getSceneTypeList();
      // 获取场景语音可用模板
      this.getTemplates();
    },
    editScene(row) {
      this.getRecorderList();
      this.dialogTitle = '编辑场景';
      this.getTransferSceneInfo();
      this.getSceneTypeList();
      this.getTemplates();
      this.addOrUpdate.id = row.id;
      this.addOrUpdate.sceneName = row.sceneName;
      this.addOrUpdate.sceneDesc = row.sceneDesc;
      this.addOrUpdate.fileds = row.fileds === null ? [] : row.fileds.split(',');
      this.sceneVisible = true;
      this.addOrUpdate.transferSceneId = row.transferSceneId;
      this.addOrUpdate.type = row.type;
      this.addOrUpdate.isInterrupt = row.isInterrupt;
      this.addOrUpdate.isFirstInterrupt = row.isFirstInterrupt;
      this.addOrUpdate.firstTimeout = row.firstTimeout;
      this.addOrUpdate.recorderId = row.recorderId;
      this.addOrUpdate.transferRingTemplateId = row.transferRingTemplateId;
      this.addOrUpdate.isFlashMsg = !!(row.isFlashMsg !== undefined ? row.isFlashMsg : row.isImmediatelyMsg);
      this.addOrUpdate.flashMsgTemplateId = row.templateId || row.flashMsgTemplateId || null;
      this.addOrUpdate.callWord = row.callWord;
      this.addOrUpdate.callWordShow = row.callWordShow;
      this.addOrUpdate.callRound = row.callRound;
      $('#manualSendMessageContent').html(this.addOrUpdate.callWordShow);
      if (row.type === 2) {
        this.showCallWord = true;
      } else {
        this.showCallWord = false;
      }
      this.isSceneType = row.type === 1 ? 1 : 0;
      this.$nextTick(() => {
        if (this.addOrUpdate.isFlashMsg) {
          this.handleImmediatelyMsgChange(true);
        } else {
          this.flashMsgTemplateList = [];
        }
      });
    },
    routeSceneShow(row) {
      this.routeScene.id = row.id;
      this.routeScene.routeConId = row.routeConId;
      this.routeSceneVisible = true;
    },
    routeSceneSave() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: '/scene/routeScene',
        data: this.routeScene
      }).then(() => {
        loading.close();
        this.routeSceneVisible = false;
        this.getData(1);
      }).catch(() => {
        loading.close();
      });
    },
    getRouteSceneOption() {
      this.routeSceneReq.companyId = this.companyId;
      this.routeSceneReq.groupId = this.groupId;
      this.$ajax({
        method: 'get',
        url: '/commonRoute/listByCompanyId',
        params: this.routeSceneReq
      }).then((res) => {
        this.routeSceneOption = res.data;
      });
    },
    addOrUpdateSceneTemplate() {
      // 如果打开了闪信开关，必须选择闪信模板
      if (this.addOrUpdate.isFlashMsg && !this.addOrUpdate.flashMsgTemplateId) {
        this.$message.warning('请选择闪信模板');
        return;
      }
      // 在克隆的DOM上提取原始参数码，避免污染编辑器实际DOM
      const contentClone = $('#manualSendMessageContent').clone();
      // 优先通过.paramFont隐藏字体提取原始码（保持与原有逻辑一致）
      const cloneFonts = contentClone.find('.paramFont');
      for (let i = 0; i < cloneFonts.length; i++) {
        contentClone.find('#p'.concat($(cloneFonts[i]).attr('id'))).replaceWith($(cloneFonts[i]).html());
      }
      // 兜底：如果无.paramFont，去除span/font标签提取纯文本内容（保留br等基础标签）
      if (cloneFonts.length === 0) {
        let cloneHtml = contentClone.html();
        // 去除所有span/font标签（保留内部文本如#LBloanInstitutionsBL#和br标签）
        cloneHtml = cloneHtml.replace(/<\/?span[^>]*>/g, '');
        cloneHtml = cloneHtml.replace(/<\/?font[^>]*>/g, '');
        contentClone.html(cloneHtml);
      }
      const payload = Object.assign({}, this.addOrUpdate, {
        templateId: this.addOrUpdate.flashMsgTemplateId,
        callWord: contentClone.html()
      });
      this.$ajax({
        prompt: true,
        url: '/scene/addOrUpdate',
        method: 'POST',
        data: payload
      }).then((res) => {
        console.warn(res);
        this.sceneVisible = false;
        this.search();
      });
    },
    openAndCloseScene(row) {
      this.$ajax({
        prompt: true,
        url: '/scene/updateStatus',
        method: 'POST',
        data: {
          id: row.id,
          status: row.status
        }
      });
    },
    deleteScene(id) {
      this.$confirm('确认删除该条场景模板?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          url: '/scene/deleteScene',
          method: 'POST',
          params: { 'id': id }
        }).then(() => {
          this.search();
        });
      });
    },
    getSceneList(groupId) {
      this.$ajax({
        url: '/scene/getSceneParam',
        method: 'POST',
        data: {
          groupId,
          type: 'svoice'
        }
      }).then((res) => {
        this.sceneTemplateList = res.data;
      });
    },

    // 场景复制
    copyScene(row) {
      this.getRecorderList();
      this.sourceCompanyChange(row.companyId);
      this.copySceneReq.id = row.id;
      this.copySceneReq.sceneName = row.sceneName;
      this.copySceneReq.sceneDesc = row.sceneDesc;
      this.copySceneReq.fileds = row.fileds === null ? [] : row.fileds.split(',');
      this.copySceneReq.sourceCompanyId = row.companyId;
      this.copySceneReq.sourceGroupId = row.groupId;
      this.copySceneReq.companyId = this.companyId;
      this.copySceneReq.groupId = this.groupId;
      this.copySceneReq.recorderId = row.recorderId;
      this.copySceneReq.callWord = row.callWord;
      this.copySceneVisible = true;
    },
    copySceneButton() {
      this.getRecorderList();
      this.sourceCompanyChange(this.companyId);
      this.copySceneReq.id = null;
      this.copySceneReq.sceneName = null;
      this.copySceneReq.sceneDesc = null;
      this.copySceneReq.fileds = [];
      this.copySceneReq.sourceCompanyId = this.companyId;
      this.copySceneReq.sourceGroupId = this.groupId;
      this.copySceneReq.companyId = this.companyId;
      this.copySceneReq.groupId = this.groupId;
      this.copySceneVisible = true;
    },
    copySceneSubmit() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$ajax({
        url: '/scene/copyScene',
        method: 'POST',
        data: this.copySceneReq
      }).then((res) => {
        loading.close();
        console.warn(res);
        this.search();
        this.copySceneVisible = false;
      }).catch(() => {
        loading.close();
      });
    },
    // 查询转人工场景
    getTransferSceneInfo() {
      const req = {
        'companyId': this.companyId,
        'groupId': this.groupId
      };
      this.$ajax({
        url: '/scene/getTransferSceneInfoList',
        method: 'POST',
        data: req
      }).then((res) => {
        this.$nextTick(() => {
          this.transferSceneOption = res.data;
        });
      });
    },
    getSceneTypeList() {
      this.$ajax({
        url: '/scene/getSceneTypeList',
        method: 'POST',
        data: {}
      }).then((res) => {
        this.$nextTick(() => {
          this.sceneTypeOption = res.data;
        });
      });
    },
    // 获取场景语音可用模板
    getTemplates() {
      const req = {
        'companyId': this.companyId,
        'groupId': this.groupId
      };
      this.$ajax({
        url: '/scene/getTemplateByCompanyId',
        method: 'post',
        data: req
      }).then((res) => {
        this.templateList = res.data;
      });
    },
    changeSceneType() {
      if (this.addOrUpdate.type === 1) {
        this.isSceneType = 1;
      } else {
        this.isSceneType = 0;
      }
      if (this.addOrUpdate.type === 2) {
        this.showCallWord = true;
      } else {
        this.showCallWord = false;
      }
      this.addOrUpdate.transferRingTemplateId = 0;
    },
    handleImmediatelyMsgChange(val) {
      if (!val) {
        this.addOrUpdate.flashMsgTemplateId = null;
        this.flashMsgTemplateList = [];
        return;
      }
      if (this.flashMsgTemplateList.length === 0) {
        this.getFlashMsgTemplates();
      }
    },
    // 获取录音员
    getRecorderList() {
      this.$ajax({
        method: 'POST',
        url: '/recorder/list',
        data: {
          status: 1
        }
      }).then((res) => {
        this.recorderOption = res.data;
      });
    },
    getFlashMsgTemplates() {
      const req = {
        'companyId': this.companyId,
        'groupId': this.groupId,
        'type': 'msg'
      };
      this.$ajax({
        url: '/template/getTemplatesParam',
        method: 'post',
        data: req
      }).then((res) => {
        this.flashMsgTemplateList = res.data || [];
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/collection/engine/voice_scene.vue